
//Iscrição Municipal

import React from 'react';

function InscMunField({ value, onChange }) {
  return (
    <div style={{ marginBottom: '0px' }}>
      <input
        type="text"
        placeholder="Digite a Inscrição Municipal"
        style={{ width: '200px', height: '30px' }}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

export default InscMunField;
